<template>
  <div class="d-flex flex-column min-height-100">
    <Header class="sticky-top flex-shrink-1"/>
    <router-view class="flex-grow-1"/>
    <Footer class="flex-shrink-1"/>
  </div>
</template>

<script>
import Header from "@/components/Header";
import Footer from "@/components/Footer";

export default {
  name: "MainLayout",
  components: { Header, Footer }
};
</script>